import React, { useEffect, useMemo } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import { Box } from '@chakra-ui/react';
import { buildExtensions, normalizeContent } from './extensions';
import { isRawMarkdownDoc, docToPlainText, markdownToHtml } from './markdown';
import './wiki-editor.css';

/**
 * Páginas antigas foram salvas com o Markdown cru em parágrafos. Em vez de exigir
 * reedição, o viewer detecta esse caso e renderiza o Markdown formatado.
 */
const prepararConteudo = (content) => {
  if (!content) return null;
  if (isRawMarkdownDoc(content)) {
    const html = markdownToHtml(docToPlainText(content));
    if (html) return html;
  }
  return normalizeContent(content);
};

const WikiContentViewer = ({ content }) => {
  const conteudoPreparado = useMemo(() => prepararConteudo(content), [content]);

  const editor = useEditor({
    extensions: buildExtensions({ viewer: true }),
    content: conteudoPreparado || '',
    editable: false,
    editorProps: {
      attributes: { class: 'wiki-editor-content wiki-viewer' },
    },
  });

  useEffect(() => {
    if (!editor) return;
    if (conteudoPreparado) editor.commands.setContent(conteudoPreparado);
  }, [conteudoPreparado, editor]);

  if (!editor) return null;

  return (
    <Box className="wiki-viewer-wrapper">
      <EditorContent editor={editor} />
    </Box>
  );
};

export default WikiContentViewer;
